import React from "react";
import { useTheme } from "@bookingcom/bui-react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import Container from "../elements/Container/index.js";
import Frame from "../elements/Frame/index.js";
import useUserAgent from "../../hooks/useUserAgent.js";
const GeniusBenefitsCarousel = () => {
    const { isMobile } = useUserAgent();
    const theme = useTheme();
    const { Component, error } = useRemoteComponent({
        project: "web-shell",
        service: "header-mfe",
        path: "/FlightsGeniusBenefitsCarousel",
        type: "capla"
    });
    return isMobile ? (React.createElement(Frame, { attributes: {
            style: {
                width: "100%",
                padding: !error ? theme.units.spacing_4x : 0
            }
        } },
        React.createElement(Component, null))) : (React.createElement(Container, { pt: !error ? 6 : 0 },
        React.createElement(Component, null)));
};
export default GeniusBenefitsCarousel;
